import Registration from './Registration.vue';
import ValidationError from './ValidationError.vue';
import SetupStatus from './SetupStatus.vue';
import SetupFinished from './SetupFinished.vue';
import RegisterFinished from './RegisterFinished.vue';
import { random } from 'underscore';

const SETUP_SERVICE_MANDATORY_PERCENT = 0;

const routes = [
    {
        path: '/register',
        name: 'RegisterForm',
        component: Registration,
        props: route => ({
            language: route.query.lang,
            cta: route.query.cta,
            siteName: route.query.sitename,
            setupServiceMandatory: random(0, 100) < SETUP_SERVICE_MANDATORY_PERCENT,
            inKRZRoute: route.query.cta !== undefined && route.query.cta.startsWith('elkw')
        })
    },
    {
        path: '/registerkrz',
        name: 'RegisterForm',
        component: Registration,
        props: route => ({
            language: route.query.lang,
            cta: route.query.cta,
            siteName: route.query.sitename,
            inKRZRoute: true
        })
    },
    {
        path: '/register/finished/:token',
        name: 'RegisterFinished',
        component: RegisterFinished
    },
    {
        path: '/validateerror/:validationToken/:registrationLanguage',
        name: 'ValidationError',
        component: ValidationError
    },
    {
        path: '/setup/finished/:token',
        name: 'SetupFinished',
        component: SetupFinished
    },
    {
        path: '/setup/:token',
        name: 'SetupStatus',
        component: SetupStatus
    }
];

export default routes;
